import {Dialog} from "@mui/material";
import {fileTypeEnum} from "../../serverClientShared/sharedEnums";
import DisplayVideo from "../RunProcedure/ProcedureMain/ProcedureMedia/DisplayVideo";
import React from "react";
import {observer} from "mobx-react";
import {useStores} from "../../Hooks";

const DayadaFilePreviewDialog = observer(() => {
    const {modalStore} = useStores();
    const filePreview = modalStore.modalData.previewedDayadaFile;
    return (
        <Dialog
            open={modalStore.isDayadaFilePreviewDialogOpen}
            onClose={() => {
                modalStore.modalData = {};
                modalStore.isDayadaFilePreviewDialogOpen = false
            }}
        >
            {filePreview ? (
                filePreview.fileType === fileTypeEnum.VIDEO ? (
                    <DisplayVideo id={filePreview.address}/>
                ) : (
                    <img
                        src={filePreview.address}
                        alt=''
                    />
                )
            ) : null}
        </Dialog>
    )
});
export default DayadaFilePreviewDialog;
